import { createSlice } from "@reduxjs/toolkit";
import { fetchUserBootstrap } from "./bootstrap.thunks";
import { reset } from "../reset";

interface BootstrapState {
    loading: boolean;
    error: string | null;
    lastFetched: number | null;
}

const initialState: BootstrapState = {
    loading: false,
    error: null,
    lastFetched: null,
};

const bootstrapSlice = createSlice({
    name: "bootstrap",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserBootstrap.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserBootstrap.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
                state.lastFetched = Date.now();
            })
            .addCase(fetchUserBootstrap.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch bootstrap data";
            })
            .addCase(reset, () => initialState);
    },
});

export default bootstrapSlice.reducer;
